import React from "react";
import { Component, HTMLProps } from "react";
import TextMask from "react-text-mask";
import { fullWidthToHalfWidth } from "checkout/ts/utils/numbers";
import { isChrome, isWindows } from "common/utils/browser";

export const SEPARATOR = "-";
const DATE_OF_BIRTH_MASK: (string | RegExp)[] = [
    /[1-9１-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    SEPARATOR,
    /[0-9０-９]/,
    /[0-9０-９]/,
    SEPARATOR,
    /[0-9０-９]/,
    /[0-9０-９]/,
];

export type DateOfBirthInputProps = Omit<HTMLProps<React.InputHTMLAttributes<string>>, "onChange"> & {
    onChange?: (value: string) => void;
};

export class DateOfBirthInput extends Component<DateOfBirthInputProps> {
    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: eventValue } = event.target as HTMLInputElement;
        this.props.onChange?.(fullWidthToHalfWidth(eventValue));
    };

    render() {
        const { value = "", ...props } = this.props;

        const skipAutoFormatting = isChrome() && isWindows();
        const disableFormattingOnCapture = (event) => {
            event.stopPropagation();
            event.preventDefault();
            return false;
        };

        return (
            <TextMask
                {...props}
                autoComplete="dob"
                type="tel"
                pattern="[0-9０-９]*"
                inputMode={skipAutoFormatting ? "search" : "numeric"}
                guide={false}
                keepCharPositions={false}
                mask={DATE_OF_BIRTH_MASK}
                placeholderChar={"\u2000"}
                onChange={this.handleChange}
                onInputCapture={skipAutoFormatting ? disableFormattingOnCapture : undefined}
                value={skipAutoFormatting ? String(value) : fullWidthToHalfWidth(String(value))}
            />
        );
    }
}
